module.exports = __webpack_public_path__ + "img/Path 23 Copy@3x.f05845b3.png";